import { defineMessages } from 'react-intl';

const messages = defineMessages({
  changePassword: 'Promijeni lozinku',
  passwordChangedSuccessfully: 'Uspješno ste promijenili lozinku!',
  passwordLabel: 'Lozinka',
  passwordRepeatLabel: 'Ponovi lozinku',
  changePasswordButton: 'Spremi',
  passwordChangeError:
    'Molimo vas ponovno se prijavite prije promjene lozinke.',
});

export default messages;
